/* @flow weak */
import { applyMiddleware, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import { reduxDispatcher } from 'lib/Dispatcher';
import combineRemindReducers from './reducer';

// Apollo docs suggest passing this into ApolloClient constructor, but
// because we use Redux outside of Apollo we have to do it through Redux
function initialStateFromWindow() {
  const initial =
    typeof window !== 'undefined' &&
    window.initialAppData &&
    window.initialAppData.reduxInitialState;
  return initial || {};
}

export function createReduxStore() {
  const middleware = applyMiddleware(thunk);

  // https://github.com/zalmoxisus/redux-devtools-extension#12-advanced-store-setup
  const composeEnhancers =
    (typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) || compose;

  // mount it on the Store
  const store = createStore(
    combineRemindReducers(),
    initialStateFromWindow(),
    composeEnhancers(middleware)
  );

  // https://github.com/gaearon/redux-devtools/blob/master/examples/counter/src/store/configureStore.dev.js
  // $FlowFixMe Flow doesn't know about `module.hot`
  if (module.hot) {
    // $FlowFixMe Flow doesn't know about `module.hot`
    module.hot.accept('./reducer', () => {
      const combineRemindReducersHot = require('./reducer').default;
      const reducers = combineRemindReducersHot();
      store.replaceReducer(reducers);
    });
  }

  reduxDispatcher.setDispatch(store.dispatch);
  return store;
}
